/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import authGuard from "./router/guards/auth";
import mainRoutes from "./router/routes/main";
import fullPageRoutes from "./router/routes/fullPage";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...mainRoutes,
    ...fullPageRoutes,
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach(authGuard);



// router.beforeRouteLeave((to, from , next) => {
//   const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
//   if (answer) {
//     next()
//   } else {
//     next(false)
//   }
// })

// router.beforeEach(async (to, from, next) => {
//   if (from.name === "menu-builder") {
//     setApplicationLocalStorageItem(
//       "menu",
//       getApplicationLocalStorageItem("currentUserMenu")
//     );
//   }

// store.dispatch("auth/reloadState");
// store.dispatch("relatedModuleNavigation/reloadState");


//   await store.dispatch("auth/reloadState");

//   if (to.path === "/login") {
//     if (getApplicationLocalStorageItem("accessToken")) {
//       await store
//         .dispatch("auth/checkSession", {
//           app_token: getApplicationLocalStorageItem("app_token"),
//           session_token: getApplicationLocalStorageItem("accessToken"),
//           api_url: getApplicationLocalStorageItem("api_url")
//         })
//         .then(async response => {
//           if (response.status === 200) {
//             let last_url = "";

//             if (getApplicationLocalStorageItem("lastUrl")) {
//               last_url = atob(
//                 getApplicationLocalStorageItem("lastUrl")
//               ).startsWith("/")
//                 ? atob(getApplicationLocalStorageItem("lastUrl"))
//                 : false;
//             }

//             if (!last_url) {
//               last_url =
//                 process.env.BASE_URL.slice(0, -1) +
//                 JSON.parse(getApplicationLocalStorageItem("role"))["home_url"];
//             }

//             location.href =
//               process.env.BASE_URL.slice(0, -1) +
//               JSON.parse(getApplicationLocalStorageItem("role"))["home_url"];
//           } else {
//             store.dispatch("auth/clearStorage");
//           }
//         })
//         .catch(err => {
//           console.log(err);
//         });

//         return next();
//     }
//   } else if (to.name === "page-reset-password-by-token") {
//     return next();
//   } else if (to.path === "/error-500") {
//     return next();
//   } else {
//     await store
//       .dispatch("auth/checkSession", {
//         app_token: getApplicationLocalStorageItem("app_token"),
//         session_token: getApplicationLocalStorageItem("accessToken"),
//         api_url: getApplicationLocalStorageItem("api_url")
//       })
//       .then(async response => {
//         if (response.status === 200) {
//           if (
//             JSON.parse(getApplicationLocalStorageItem("user"))
//               .change_password &&
//             to.name !== "page-reset-password"
//           ) {
//             router.push({ name: "page-reset-password" });
//           } else if (to.name === "modules") {
//             if (from.name === "modules") {
//               // router.go()
//             } else {

//             }
//           } else if (to.name === "menu-builder") {
//             if (from.name !== null) {
//               setApplicationLocalStorageItem("needReload", "true");

//             } else {

//             }
//           } else {

//           }
//         } else {
//           store.dispatch("auth/clearStorage");
//           store.dispatch("auth/signOut");
//         }

//         return next();
//       })
//       .catch(err => {
//         console.log(err);
//       });
//   }



//   return next();

// });

export default router;
